module.exports = __webpack_public_path__ + "img/lb11.7771339b.svg";